import React from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import './pageTitle.css';

const TitleWithIcon = ({
    title,
    subtitle,
    className = "",
    showStatus = false,
    status,
    warningTooltipText,
}) => {
    const { t } = useTranslation("layout");
    const normalizedWarningText = String(warningTooltipText ?? "").trim();
    const hasWarning = Boolean(normalizedWarningText);

    return (
        <div className={`title-with-icon ${className}`}>
            <div className="title-with-icon__content">
                <div className="title-with-icon__title-row">
                    <span className="title-with-icon__title">
                        {title}
                    </span>
                    {hasWarning && (
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip
                                    id="patient-comment-tooltip"
                                    className="patient-comment-tooltip"
                                >
                                    {normalizedWarningText}
                                </Tooltip>
                            }
                        >
                            <button
                                type="button"
                                className="title-with-icon__warning"
                                aria-label={t("pageTitle.showComment")}
                            >
                                !
                            </button>
                        </OverlayTrigger>
                    )}
                </div>
                {subtitle && (
                    <span className="title-with-icon__subtitle">{subtitle}</span>
                )}
            </div>
        </div>
    );
};

export default TitleWithIcon;
